(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["srv-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buildMarquee = (section) => {
      const source = section.querySelector('.srv-instagram__source');
      const marquee = section.querySelector('[data-srv-instagram-marquee]');
      const track = marquee?.querySelector('.srv-instagram__track');

      if (!source || !marquee || !track) return false;

      const posts = [];
      const seen = new Set();

      const getImageSrc = (image) => {
        if (!image) return null;

        const srcset = image.dataset.srcset || image.getAttribute('srcset');
        const srcsetSrc = srcset?.split(',')?.[0]?.trim()?.split(' ')?.[0];

        return image.dataset.instafeedSrc
          || image.dataset.src
          || image.dataset.original
          || image.currentSrc
          || image.src
          || srcsetSrc
          || null;
      };

      const candidates = source.querySelectorAll('.instafeed-new-layout-item');

      candidates.forEach((item) => {
        const link = item.querySelector('a[href*="instagram.com"]');
        const image = link?.querySelector(':scope > img[data-instafeed-src], :scope > img[data-src], :scope > img[data-original], :scope > img[src], :scope > img[srcset]');
        const href = link?.href || 'https://www.instagram.com/serviette.nyc/';
        const src = item.dataset.instafeedThumbnail || getImageSrc(image);

        if (!src || src.startsWith('data:') || !link || seen.has(href)) return;

        seen.add(href);
        posts.push({ href, src, alt: image?.alt || 'Serviette on Instagram' });
      });

      if (!posts.length) return false;
      const marqueePosts = posts.slice(0, 12);
      const styles = window.getComputedStyle(section);
      const cardSize = window.parseFloat(styles.getPropertyValue('--srv-instagram-card')) || 100;
      const gap = window.parseFloat(styles.getPropertyValue('--srv-instagram-gap')) || 0;
      const cardSpan = cardSize + gap;
      const viewportWidth = section.clientWidth || document.documentElement.clientWidth;
      const requiredPosts = Math.max(
        marqueePosts.length,
        Math.ceil((viewportWidth + cardSpan) / cardSpan)
      );
      const groupPosts = Array.from(
        { length: requiredPosts },
        (_, index) => marqueePosts[index % marqueePosts.length]
      );
      const pixelsPerSecond = window.matchMedia('(max-width: 767px)').matches ? 5.12 : 8.28;

      section.style.setProperty(
        '--srv-instagram-duration',
        `${(groupPosts.length * cardSpan) / pixelsPerSecond}s`
      );

      const makeGroup = (isClone = false) => {
        const group = document.createElement('div');
        group.className = 'srv-instagram__group';

        if (isClone) group.setAttribute('aria-hidden', 'true');

        groupPosts.forEach((post, index) => {
          const link = document.createElement('a');
          const image = document.createElement('img');

          link.className = 'srv-instagram__post';
          link.href = post.href;
          link.target = '_blank';
          link.rel = 'noopener nofollow';
          link.setAttribute('aria-label', `View Instagram post ${index + 1}`);

          if (isClone) link.tabIndex = -1;

          image.src = post.src;
          image.alt = isClone ? '' : post.alt;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 100;
          image.height = 100;
          link.appendChild(image);
          group.appendChild(link);
        });

        return group;
      };

      track.replaceChildren(makeGroup(), makeGroup(true));
      source.classList.add('is-cloned');
      marquee.hidden = false;
      return true;
    };

    const initialize = (section) => {
      if (!section.srvInstagramResizeObserver && 'ResizeObserver' in window) {
        let previousWidth = Math.round(section.clientWidth);
        let resizeTimer;

        section.srvInstagramResizeObserver = new ResizeObserver(([entry]) => {
          const currentWidth = Math.round(entry.contentRect.width);

          if (!currentWidth || currentWidth === previousWidth) return;

          previousWidth = currentWidth;
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(() => buildMarquee(section), 150);
        });

        section.srvInstagramResizeObserver.observe(section);
      }

      if (buildMarquee(section)) return;

      const source = section.querySelector('.srv-instagram__source');
      if (!source) return;

      const observer = new MutationObserver(() => {
        if (buildMarquee(section)) observer.disconnect();
      });

      observer.observe(source, {
        attributes: true,
        childList: true,
        subtree: true
      });

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (buildMarquee(section) || attempts >= 30) {
          if (attempts >= 30) source.classList.add('is-cloned');
          window.clearInterval(timer);
          observer.disconnect();
        }
      }, 500);
    };

    document.querySelectorAll('.srv-instagram').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.srv-instagram');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srv-raw-materials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var desktopQuery = window.matchMedia('(min-width: 768px)');

    function activateDesktop(section, id) {
      section.querySelectorAll('[data-raw-detail]').forEach(function(detail) {
        detail.classList.toggle('is-active', detail.getAttribute('data-raw-detail') === id);
      });
      section.querySelectorAll('[data-raw-trigger]').forEach(function(trigger) {
        trigger.classList.toggle('is-active', trigger.getAttribute('data-raw-trigger') === id);
      });
    }

    function activateFirstDesktop(section) {
      if (!desktopQuery.matches) return;
      if (section.querySelector('[data-raw-detail].is-active')) return;

      var firstTrigger = section.querySelector('[data-raw-trigger]');
      if (firstTrigger) {
        activateDesktop(section, firstTrigger.getAttribute('data-raw-trigger'));
      }
    }

    function closeMobile(section) {
      section.querySelectorAll('[data-raw-mobile-panel]').forEach(function(panel) {
        panel.classList.remove('is-open');
      });
      section.querySelectorAll('[data-raw-mobile-trigger]').forEach(function(trigger) {
        trigger.classList.remove('is-open');
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function toggleMobile(section, trigger) {
      var id = trigger.getAttribute('data-raw-mobile-trigger');
      var panel = section.querySelector('[data-raw-mobile-panel="' + id + '"]');
      var wasOpen = trigger.classList.contains('is-open');
      closeMobile(section);

      if (panel && !wasOpen) {
        panel.classList.add('is-open');
        trigger.classList.add('is-open');
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    function initSection(section) {
      if (section.getAttribute('data-raw-materials-ready') === 'true') return;
      section.setAttribute('data-raw-materials-ready', 'true');

      section.addEventListener('mouseover', function(event) {
        if (!desktopQuery.matches) return;
        var trigger = event.target.closest('[data-raw-trigger]');
        if (!trigger || !section.contains(trigger)) return;
        activateDesktop(section, trigger.getAttribute('data-raw-trigger'));
      });

      section.addEventListener('focusin', function(event) {
        if (!desktopQuery.matches) return;
        var trigger = event.target.closest('[data-raw-trigger]');
        if (!trigger || !section.contains(trigger)) return;
        activateDesktop(section, trigger.getAttribute('data-raw-trigger'));
      });

      section.addEventListener('click', function(event) {
        var trigger = event.target.closest('[data-raw-mobile-trigger]');
        if (!trigger || !section.contains(trigger)) return;

        if (desktopQuery.matches) {
          activateDesktop(section, trigger.getAttribute('data-raw-trigger'));
          return;
        }

        toggleMobile(section, trigger);
      });

      activateFirstDesktop(section);
    }

    function init(root) {
      root.querySelectorAll('.srv-raw-materials__inner').forEach(initSection);
    }

    function activateDesktopDefaults(root) {
      root.querySelectorAll('.srv-raw-materials__inner').forEach(activateFirstDesktop);
    }

    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });

    document.addEventListener('shopify:section:load', function(event) {
      init(event.target);
    });

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', function(event) {
        if (event.matches) activateDesktopDefaults(document);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srv-spritz-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  var link = event.target.closest('.srv-guide__foot [data-srv-guide-back-to-top]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
}, true);
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  var link = event.target.closest('.srv-guide__mobile-contents a[href^="#"]');
  if (!link) return;
  var menu = link.closest('details');
  if (menu) menu.open = false;
});

  } catch(e) { console.error(e); }
})();
})();
